import Vue from 'vue';

export default {
    namespaced: true,

    state: {
        all: {},
    },

    mutations: {
        setAll(state, all) {
            let translations = {};
            for (let [name, catalog] of Object.entries(all)) {
                translations[name] = catalog.reduce((result, [key, value]) => {
                    result[key+''] = value;
                    return result;
                }, {});
            }
            Vue.$i18n.import('de', translations);
            state.all = all;
        },
    },

    getters: {
        translate: (...args) => Vue.$i18n.get(...args),

        getCatalog: (state) => catalog_name => {
            if (!state.all.hasOwnProperty(catalog_name)) {
                throw `Unknown catalog '${catalog_name}'`;
            }
            return state.all[catalog_name];
        },

        getForSelect: (state, getters) => catalog_name => {
            return getters.getCatalog(catalog_name).map(([key, label]) => ({key, label}));
        },
    },

};